<template>
  <div class="item" @click="selecItem">
    {{itemData.hospitalName}}
  </div>
</template>

<script>

export default {
  props: {
    itemData: {
      type: Object,
      value: null,
    },
  },
  methods: {
    selecItem() {
      this.$store.commit('hospitalItem', { ...this.itemData, });
      this.$router.go(-1);
    },
  },
};

</script>

<style lang='scss' scoped>
.item {
  height: 44px;
  padding-left: 15px;
  padding-right: 15px;

  @include flex(center,flex-start);
  @include font(14px,1,#1F2229);
}
</style>
